
function infoAccordion() {
    const accordionItems = document.querySelectorAll(".additional-info-item");

    if (!accordionItems.length) return;

    accordionItems.forEach((item) => {
      const header = item.querySelector(".additional-info-item-header");
      const content = item.querySelector(".additional-info-item-content");

      header.addEventListener("click", (e) => {
        console.log("E", e);
        e.stopPropagation(); // Prevent triggering the outside click handler

        const isActive = header.classList.contains("active");
        // Close all items
        closeAllAccordionItems();

        if (!isActive) {
          header.classList.add("active");
          // content.style.maxHeight = content.scrollHeight + "px";
          content.classList.add("active");

          // --- Safari/iOS FIX ---
        content.style.maxHeight = "none";     // reset first
        void content.offsetHeight;            // force reflow

        // Delay just a little so Safari recalculates properly
        setTimeout(() => {
          content.style.maxHeight = content.scrollHeight + "px";
        }, 10);
          
        }
      });
    });

    function closeAllAccordionItems() {
      accordionItems.forEach((item) => {
        const header = item.querySelector(".additional-info-item-header");
        const content = item.querySelector(".additional-info-item-content");
        header.classList.remove("active");
        content.classList.remove("active");
        content.style.maxHeight = null;
      });
    }

  }

document.addEventListener("DOMContentLoaded", infoAccordion);

document.addEventListener('variant:change', infoAccordion)



















